import React, { ReactElement } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import type { HTMLAttributes } from 'react'

interface OrgStaticWrapperProps extends HTMLAttributes<HTMLDivElement> {
  sx?: ThemeUIStyleObject
}

export function StaticPageWrapper({ sx, children, ...props }: OrgStaticWrapperProps): ReactElement {
  return (
    <Flex
      sx={{
        // 100vw (rather than 100%) so that content doesn't jump when custom
        // scrollbar appears/ disappears on desktop
        width: '100vw',
        position: 'relative',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'blue800',
        /*
           If we set overflow to 'hidden' on any ancestor of the sticky element(OrgStaticPageHeader),
           then this ancestor element will be the scrolling container for OrgStaticPageHeader.
           overflow: 'clip' works almost the same way as overflow: 'hidden',
           except the anchor point of the sticky element(OrgStaticPageHeader) is unaffected.
          */
        overflow: 'clip',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Flex>
  )
}
